export var MultifactorAuthIA = function MultifactorAuthIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MULTIFACTOR_AUTHENTICATION(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_HAVE_IMPLEMENTED_SECURITY_MEASURES(strictLocalize), IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize)];
    }
  };
};
var MULTIFACTOR_AUTHENTICATION = function MULTIFACTOR_AUTHENTICATION(strictLocalize) {
  return strictLocalize({
    id: "riBx2l",
    defaultMessage: [{
      "type": 0,
      "value": "Multifactorverificatie"
    }]
  });
};
var WE_HAVE_IMPLEMENTED_SECURITY_MEASURES = function WE_HAVE_IMPLEMENTED_SECURITY_MEASURES(strictLocalize) {
  return strictLocalize({
    id: "q2lRAt",
    defaultMessage: [{
      "type": 0,
      "value": "Bij Faire hebben we beveiligingsmaatregelen geïmplementeerd om je account te beschermen tegen ongeautoriseerde toegang. Als onderdeel van deze maatregelen kunnen we aanvullende informatie vragen, zoals een multifactorverificatie (MFA)-code, om ervoor te zorgen dat alleen jij toegang hebt tot je account. Dit wordt gedaan om de beveiliging en privacy van je account te beschermen en mogelijke ongeautoriseerde activiteiten te voorkomen."
    }]
  });
};
var IF_YOU_HAVE_ANY_QUESTIONS = function IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "L5tq/m",
    defaultMessage: [{
      "type": 0,
      "value": "Contacteer ons als je nog vragen of opmerkingen hebt over multifactorverificatie."
    }]
  });
};